import React, {Component} from 'react';
import './LabelShippingPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Input from '../../inputs/input/Input';
import mainAPI from '../../api/MainAPI';
import UniversalDropDown from '../../components/universalDropDown/UniversalDropDown';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import toasts from '../../utils/toasts';
import utils from "../../utils/utils";
import debounce from 'lodash.debounce';
import models from "../../model/models";

export default class LabelShippingPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			labelRequest: null,
			userGroups: [],
			labelRequestStats: null
		};
		this.myRefs = {};
		this.debouncedSave = debounce(this.saveField, 1000);
	}

	componentDidMount = async () => {
		await this.update();
	}



	fetchLabelRequestStats = async () => {
		const { labelRequest } = this.state;
		// eslint-disable-next-line no-undef
		if (labelRequest?.user_group_id) {
			const stats = await mainAPI.label_request.stats(labelRequest.user_group_id);
			this.setState({ labelRequestStats: stats });
		}
	}

	update = async () => {
		const id = this.props.match.params.id;
		const labelRequest = await mainAPI.label_request.get(id);
		const userGroups = await mainAPI.user_group.all();
		this.setState({ 
			labelRequest,
			userGroups
		});
		await this.fetchLabelRequestStats();
	};

	handleUserGroupChange = async (value) => {
		const {labelRequest} = this.state;
		const response = await mainAPI.label_request.update({
			id: labelRequest.id,
			_user_group_id: value
		});

		if (response) {
			toasts.show('User group updated successfully');
		} else {
			toasts.show('Failed to update user group');
		}
		await this.update();
	};

	handleMarkAsSent = async () => {
		try {
			let {labelRequest, selectedUserGroupId} = this.state;
			if(!selectedUserGroupId) {
				selectedUserGroupId = this.myRefs.user_group_id.getValue();
			}
			await mainAPI.label_request.update({
				id: labelRequest.id,
				_user_group_id: selectedUserGroupId,
				fulfilled_by_id: models.user.getCurrent().id,
				sent_on: utils.client_to_server_datetime(new Date())
			});
			toasts.show('Label request marked as sent');
			const updatedLabelRequest = await mainAPI.label_request.get(labelRequest.id);
			this.setState({labelRequest: updatedLabelRequest});
		} catch (error) {
			toasts.show('Failed to update label request');
		}
	};

	handleCountChange = (field, value) => {
		const { labelRequest } = this.state;
		const newValue = parseInt(value) || 0;
		
		this.setState(prevState => ({
			labelRequest: {
				...prevState.labelRequest,
				[field]: newValue,
				...(field !== 'box_seals_count' && {
					label_total: this.calculateNewLabelTotal(prevState.labelRequest, field, newValue)
				})
			}
		}));

		this.debouncedSave(field, newValue, labelRequest.id);
	};

	saveField = async (field, newValue, labelRequestId) => {
		try {
			const updateData = {
				id: labelRequestId,
				[field]: newValue
			};

			if (field !== 'box_seals_count') {
				const currentLabelRequest = this.state.labelRequest;
				updateData.label_total = this.calculateNewLabelTotal(currentLabelRequest, field, newValue);
			}

			await mainAPI.label_request.update(updateData);
			toasts.show(`${field.replace('_', ' ')} updated successfully`);
		} catch (error) {
			toasts.show(`Failed to update ${field.replace('_', ' ')}`);
			await this.update();
		}
	};

	calculateNewLabelTotal = (currentLabelRequest, changedField, newValue) => {
		if (changedField === 'box_seals_count') {
			return currentLabelRequest.label_total;
		}

		return Object.keys(currentLabelRequest)
			.filter(key => key.endsWith('_count') && key !== 'box_seals_count')
			.reduce((total, key) => {
				if (key === changedField) {
					return total + newValue;
				}
				return total + (currentLabelRequest[key] || 0);
			}, 0);
	};

	render() {
		const {labelRequest, userGroups, labelRequestStats} = this.state;
		if (!labelRequest) return null;

		const userGroupOptions = userGroups.reduce((acc, group) => {
			acc[group.id] = group.name;
			return acc;
		}, {});

		const wasSent = isValidDate(labelRequest.sent_on);

		return (
			<Page className="g-label-shipping-page">
				<Card>
					<Label larger black>Label Request Details</Label>

					<div className="details-section">

						<Label bold black>Sent On:</Label>
						<Label>{wasSent ? new Date(labelRequest.sent_on).toLocaleString() : 'Not sent yet'}</Label>


						<Label bold black>Contact Name:</Label>
						<Label>{labelRequest.contact_name || 'Not provided'}</Label>

						<Label bold black>Address:</Label>
						<Label>{labelRequest.address || 'Not provided'}</Label>

						<Label bold black>Agency Name:</Label>
						<Label>{labelRequest.agency_name}</Label>
						<Label bold black>User Group:</Label>
						<UniversalDropDown
							ref={ref=>this.myRefs.user_group_id = ref}
							value={labelRequest.user_group_id}
							options={userGroupOptions}
							onChange={this.handleUserGroupChange}
						/>

						<Label bold black>Label Counts:</Label>
						<div className="label-counts">
							<div className="count-input-row">
								<Label>Blue:</Label>
								<Input
									type="number"
									min="0"
									value={labelRequest.blue_count || 0}
									onChange={(value) => this.handleCountChange('blue_count', value)}
									className="count-input"
									disabled={wasSent}
								/>
							</div>
							<div className="count-input-row">
								<Label>Red:</Label>
								<Input
									type="number"
									min="0"
									value={labelRequest.red_count || 0}
									onChange={(value) => this.handleCountChange('red_count', value)}
									className="count-input"
									disabled={wasSent}
								/>
							</div>
							<div className="count-input-row">
								<Label>Green:</Label>
								<Input
									type="number"
									min="0"
									value={labelRequest.green_count || 0}
									onChange={(value) => this.handleCountChange('green_count', value)}
									className="count-input"
									disabled={wasSent}
								/>
							</div>
							<div className="count-input-row">
								<Label>Yellow:</Label>
								<Input
									type="number"
									min="0"
									value={labelRequest.yellow_count || 0}
									onChange={(value) => this.handleCountChange('yellow_count', value)}
									className="count-input"
									disabled={wasSent}
								/>
							</div>
							<div className="count-input-row">
								<Label>Purple:</Label>
								<Input
									type="number"
									min="0"
									value={labelRequest.purple_count || 0}
									onChange={(value) => this.handleCountChange('purple_count', value)}
									className="count-input"
									disabled={wasSent}
								/>
							</div>
							<div className="count-input-row">
								<Label>Orange:</Label>
								<Input
									type="number"
									min="0"
									value={labelRequest.orange_count || 0}
									onChange={(value) => this.handleCountChange('orange_count', value)}
									className="count-input"
									disabled={wasSent}
								/>
							</div>
							<div className="count-input-row">
								<Label>White:</Label>
								<Input
									type="number"
									min="0"
									value={labelRequest.white_count || 0}
									onChange={(value) => this.handleCountChange('white_count', value)}
									className="count-input"
									disabled={wasSent}
								/>
							</div>
							<div className="count-input-row">
								<Label>Black:</Label>
								<Input
									type="number"
									min="0"
									value={labelRequest.black_count || 0}
									onChange={(value) => this.handleCountChange('black_count', value)}
									className="count-input"
									disabled={wasSent}
								/>
							</div>
						</div>

						<Label bold black>Total Labels:</Label>
						<Label>{labelRequest.label_total}</Label>

						<Label bold black>Box Seals:</Label>
						<Input
							type="number"
							min="0"
							value={labelRequest.box_seals_count || 0}
							onChange={(value) => this.handleCountChange('box_seals_count', value)}
							className="count-input"
							disabled={wasSent}
						/>

						<Label bold black>Requested On:</Label>
						<Label>{new Date(labelRequest.created_on).toLocaleString()}</Label>
					</div>

					{!wasSent && (
						<PrimaryButton
							center
							onClick={this.handleMarkAsSent}
						>
							Mark as Sent
						</PrimaryButton>
					)}
				</Card>

				<Card className="stats-card">
					<Label larger black>Agency Statistics</Label>
					{labelRequestStats ? (
						<div className="stats-table">
							<div className="stats-row">
								<Label bold black>Agency:</Label>
								<Label>{labelRequestStats.user_group_name}</Label>
							</div>
							<div className="stats-row">
								<Label bold black>Total Units:</Label>
								<Label>{labelRequestStats.total_units}</Label>
							</div>
							<div className="stats-row">
								<Label bold black>Total Usage Count:</Label>
								<Label>{labelRequestStats.total_usage_count}</Label>
							</div>
							<div className="stats-row">
								<Label bold black>Total Labels Sent:</Label>
								<Label>{labelRequestStats.total_labels_sent}</Label>
							</div>
							<div className="stats-row">
								<Label bold black>Years Active:</Label>
								<Label>{labelRequestStats.years_active.toFixed(1)}</Label>
							</div>
							<div className="stats-row">
								<Label bold black>Average Usage Per Year:</Label>
								<Label>{labelRequestStats.avg_usage_per_year}</Label>
							</div>
						</div>
					) : (
						<Label>Loading stats...</Label>
					)}
				</Card>
			</Page>
		);
	}
}
function isValidDate(value) {
	const date = new Date(value);
	return !isNaN(date.getTime());
}


// WEBPACK FOOTER //
// ./src/pages/labelShippingPage/LabelShippingPage.jsx